import Spinner from "../common/Spinner"
import { AccordionRoot, AccordionItem, AccordionItemContent } from "../ui/accordion"
import { useState, useEffect } from "react"

function Widget({ children }) {
  return (
    <div className='relative flex flex-col bg-grey-900 rounded w-full mb-2'>
      {children}
    </div>
  )
}

function WidgetHeader({
  title,
  showSpinner = false,
  actionIcon = null,
  overrideHeaderStyle = false,
  children
}) {
  const widgetTitle = (
    <h3 className={`font-header font-semibold text-md text-green ${overrideHeaderStyle ? '' : 'mb-1'}`}>
      {title}
    </h3>
  )

  const spinner = showSpinner && (
    <div className="absolute right-2 top-2.5">
      <Spinner color="grey-300" height="20px" width="20px" strokeWidth={6} />
    </div>
  )

  const action = !showSpinner && actionIcon && (
    <div className={overrideHeaderStyle ? '' : 'absolute right-2 top-2.5'}>
      {actionIcon}
    </div>
  )

  return (
    <div className="relative flex flex-col w-full sticky top-0 z-30 bg-grey-900 p-2">
      {overrideHeaderStyle ? (
        <div className="flex items-center justify-between mb-1">
          {widgetTitle}
          {spinner}
          {action}
        </div>
      ) : (
        <>
          {widgetTitle}
          {spinner}
          {action}
        </>
      )}
      {children}
    </div>
  )
}

function WidgetBody({ styles = "", isVisible = true, children }) {
  const [accordionControl, setAccordionControl] = useState(isVisible ? ['body'] : [])

  useEffect(() => {
    setAccordionControl(isVisible ? ['body'] : [])
  }, [isVisible])

  return (
    <AccordionRoot
      type="single"
      collapsible
      onValueChange={setAccordionControl}
      value={accordionControl}
    >
      <AccordionItem value="body">
        <AccordionItemContent p={0}>
          <div className={`${styles} px-1`}>
            {children}
          </div>
        </AccordionItemContent>
      </AccordionItem>
    </AccordionRoot>
  )
}

function WidgetFooter({ isSticky = false, children }) {
  return (
    <div className={`flex flex-col w-full bg-grey-900 p-2 ${isSticky && "sticky bottom-0 z-30"}`}>
      {children}
    </div>
  )
}

export { Widget, WidgetHeader, WidgetBody, WidgetFooter }